import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { Card } from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';
import { Button } from '@/components/ui/Button';

/**
 * Lands here after the Cognito Hosted UI redirect. react-oidc-context processes
 * the authorization code automatically; we just wait and then navigate home.
 */
export function CallbackPage() {
  const { isLoading, isAuthenticated, error, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  if (error) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <Card className="w-full max-w-sm text-center">
          <h1 className="text-lg font-semibold text-gray-900">Sign-in failed</h1>
          <p className="mt-2 text-sm text-gray-600">{error.message}</p>
          <div className="mt-4">
            <Button onClick={() => void signIn()}>Try again</Button>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <Spinner label={isLoading ? 'Completing sign in' : 'Redirecting'} />
    </div>
  );
}
